import { useUserStore } from '~/stores/auth';
import { DEBUG, GLOBAL_MESSAGE_EVENT, type PayloadDataType } from './index';
import { useChannelsStore } from '~/stores/channels';
import type { Emitter } from '~/plugins/emitter';

type CreateMember = {
  eventType:
    | 'create-member'
    | 'channel-access-granted'
    | 'channel-access-removed';
  email: string;
  channelId: number;
  teamId: number;
  userId: number;
  userName: string;
  auditUserId: number;
  teamName: string;
};

const contextUser = (userId: number) => {
  const piniaUser = useUserStore();
  const ctxId = piniaUser.user as unknown as {
    summary: { basicUserInfo: { userId: number } };
  };
  return ctxId.summary.basicUserInfo.userId === userId;
};
export function handleCreateMember(
  ...[_channel, data]: PayloadDataType<CreateMember>
) {
  if (DEBUG) console.log('handlePusherMessages', data);

  const piniaChannels = useChannelsStore();

  piniaChannels.refetchAffectedMemberCaches(data.channelId, data.teamId);
  piniaChannels.refetchAffectedMemberDetail(
    data.channelId,
    `${data.channelId}-${data.userId}`
  );

  const emitter = useNuxtApp().$emitter as Emitter;
  if (contextUser(data.auditUserId)) {
    emitter.$emit(GLOBAL_MESSAGE_EVENT, {
      message: `New member ${data.userName} has been added to ${data.teamName} team.`,
      status: 200,
    });
  }
}
